import React from "react";
import Button from "reactstrap/lib/Button";
import classname from "classnames";

export enum ProductListViewMode {
    cardView = 0,
    listView = 1,
    compactView = 2
}

export interface IProductListViewModeDisable {
    cardView?: boolean;
    listView?: boolean;
    compactView?: boolean;
}

export interface IProductListViewModeProps {
    viewMode: ProductListViewMode | undefined;
    cardButtonTxt?: string;
    listButtonTxt?: string;
    compactButtonTxt?: string;
    disableView?: IProductListViewModeDisable
    setListViewMode?: (() => void);
    setCardViewMode?: (() => void);
    setCompactViewMode?: (() => void);
}

export const ProductListViewModeComponent: React.FC<IProductListViewModeProps> = (props: IProductListViewModeProps) => {
    const { disableView } = props;

    return (
        <div className='dlvry-view-modes-selector'>
            {!disableView?.cardView && (
                <Button
                    className={classname(
                        'card_view',
                        (props.viewMode === ProductListViewMode.cardView) ? 'selected' : ''
                    )}
                    title={props.cardButtonTxt || 'Varekort'}
                    aria-label={props.cardButtonTxt || 'Varekort'}
                    role='button'
                    onClick={props.setCardViewMode}
                >
                    <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' width='16px' height='16px'>
                        <rect x='3' y='3' width='7' height='7' rx='1.5'></rect>
                        <rect x='14' y='3' width='7' height='7' rx='1.5'></rect>
                        <rect x='3' y='14' width='7' height='7' rx='1.5'></rect>
                        <rect x='14' y='14' width='7' height='7' rx='1.5'></rect>
                    </svg>
                </Button>
            )}
            {!disableView?.listView && (
                <Button
                    className={classname(
                        'list_view',
                        (props.viewMode === ProductListViewMode.listView) ? 'selected' : ''
                    )}
                    title={props.listButtonTxt || 'Liste'}
                    aria-label={props.listButtonTxt || 'Liste'}
                    role='button'
                    onClick={props.setListViewMode}
                >
                    <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' width='16px' height='16px'>
                        <rect x='3' y='4' width='18' height='5' rx='1.5'></rect>
                        <rect x='3' y='13' width='18' height='5' rx='1.5'></rect>
                    </svg>
                </Button>
            )}
            {!disableView?.compactView && (
                <Button
                    className={classname(
                        'compact_view',
                        (props.viewMode === ProductListViewMode.compactView) ? 'selected' : ''
                    )}
                    title={props.compactButtonTxt || 'Kompakt'}
                    aria-label={props.compactButtonTxt || 'Kompakt'}
                    role='button'
                    onClick={props.setCompactViewMode}
                >
                    <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' width='16px' height='16px'>
                        <path d='M4 6h16M4 12h16M4 18h16'></path>
                    </svg>
                </Button>
            )}
        </div>
    );
};
